import { App } from 'antd';

export const useAppNotification = () => {
  const { notification } = App.useApp();

  const showError = (message: string, description?: string) => {
    notification.error({
      message,
      description,
      placement: 'topRight',
      duration: 5,
    });
  };

  const showSuccess = (message: string, description?: string) => {
    notification.success({
      message,
      description,
      placement: 'topRight',
      duration: 3,
    });
  };

  const showWarning = (message: string, description?: string) => {
    notification.warning({
      message,
      description,
      placement: 'topRight',
      duration: 4,
    });
  };

  return { showError, showSuccess, showWarning };
};
